import React, { memo, useRef } from 'react';
import { formats } from 'investira.sdk';
import { Stack, Typography, Chip, useMediaQuery, Icon } from 'investira.react.components';
import { displays } from 'investira.react.lib';
import { ATIVO_MERCADO } from '@investirapri/financa.js/lib/enums';
import { PessoaImage } from '../../molecules';

/**
 * Renderiza o componente SearchIndicadoresItem.
 *
 * @param {Object} props - Propriedades do componente.
 * @param {*} props.data - Propriedade `data` do componente.
 * @param {*} props.onClick - Propriedade `onClick` do componente.
 *
 * @description
 * Este componente realiza as seguintes operacoes:
 * 1. Recebe as propriedades necessarias para compor a interface
 * 2. Organiza os estados e callbacks usados durante a renderizacao
 * 3. Renderiza a experiencia visual do organismo
 *
 * @returns {JSX.Element|null} Elemento renderizado pelo componente.
 */

const SearchIndicadoresItem = memo(props => {
  const { data, onClick } = props;
  const isUpMd = useMediaQuery(theme => theme.breakpoints.up('md'));

  const INDICADORES_TIPO = useRef({
    M: {
      label: 'Moeda',
      id: 'M',
      icon: 'coin'
    },
    C: {
      label: 'Correção Monetária',
      id: 'C',
      icon: 'coins'
    },
    I: {
      label: 'Índice de Mercado',
      id: 'I',
      icon: 'chart_line'
    },
    J: {
      label: 'Juros',
      id: 'J',
      icon: 'percent'
    },
    T: { label: 'Metal', id: 'T', icon: 'metal' }
  });

  const xIndicadoresTipo = INDICADORES_TIPO.current;

  return (
    <Stack
      id={data.indicador_id}
      key={data.indicador_id}
      direction="row"
      flexGrow={1}
      spacing={3}
      alignItems="flex-start"
      component="li"
      onClick={onClick}
      sx={{
        px: 2,
        py: 2,
        cursor: 'pointer',
        '&:hover': {
          color: 'gray',
          backgroundColor: 'background.main'
        },
        borderBottom: '1px solid',
        borderBottomColor: 'background.main'
      }}>
      {data?.indicador_tipo_id && xIndicadoresTipo[data.indicador_tipo_id] && (
        <Stack
          backgroundColor="primary.main"
          width="36px"
          height="36px"
          justifyContent="center"
          alignItems="center"
          borderRadius="8px">
          <Icon
            iconName={xIndicadoresTipo[data.indicador_tipo_id].icon}
            color="secondary"
            size={18}
          />
        </Stack>
      )}
      <Stack flexGrow={1}>
        <Typography variant="body2" color="textPrimary" sx={{ fontWeight: 600 }}>
          {data.indicador_id}
        </Typography>
        <Stack direction="row" spacing={{ xs: 0, sm: 1 }} mb={1}>
          <Typography
            variant="caption"
            color="textPrimary"
            sx={{
              display: { xs: 'none', sm: 'inline-block' }
            }}>
            {data.indicador}
          </Typography>
        </Stack>
      </Stack>

      {data?.indicador_tipo_id && xIndicadoresTipo[data.indicador_tipo_id] && (
        <Stack>
          <Stack justifyContent="end">
            <Chip
              label={xIndicadoresTipo[data.indicador_tipo_id].label}
              size="small"
              color="primary"
            />
          </Stack>
        </Stack>
      )}
    </Stack>
  );
});

export default SearchIndicadoresItem;
